import salesTypes from 'maps/sales-types';

import getSalesTypeOptions from 'helpers/getSalesTypeOptions';
import getInitialSalesType from 'helpers/getInitialSalesType';
import { EntityTypes } from 'context/entityContext';

export default handleBrowseEntityType;
/*
 * Because "Labels" uses different metrics we need to update
 * the active sorting metric to its default as well as the sales type.
 */

interface IProps {
  value: EntityTypes;
  isExternalUser: boolean;
  salesType: {
    label: string;
    value: string;
  };
  saveComponentSettings: Function;
}
function handleBrowseEntityType(args: IProps): void {
  const { value, isExternalUser, salesType, saveComponentSettings } = args;

  const allowedSalesTypes: {
    label: string;
    value: string;
  }[] = getSalesTypeOptions(isExternalUser, value, false);
  function hasSelectedSalesType(allowedSalesType: {
    label: string;
    value: string;
  }): boolean {
    return allowedSalesType.value === salesType.value;
  }

  if (value !== 'label' && !allowedSalesTypes.some(hasSelectedSalesType)) {
    const initalSalesValue = getInitialSalesType(isExternalUser, value);
    saveComponentSettings({
      selectedSalesType: salesTypes[initalSalesValue as any],
    });
  }

  saveComponentSettings({
    browseEntityType: value,
  });
}
